export const typesenseTypoConfigForProjectsCollection = {
    min_len_1typo: 5,
    min_len_2typo: 8,
};
/**
 * Configs for Typesense users search in global site search.
 *
 * We don't configure infix here because it doens't work well
 * with multi search, need to check with Typesense team
 */
export const typesenseConfigForSiteSearchUsers = {
    min_len_1typo: 4,
    min_len_2typo: 8,
    // Trying to match as many results as possible, but not monopolizing
    // CPU in one query
    drop_tokens_threshold: 10,
    typo_tokens_threshold: 10,
    // Cache for identical search
    use_cache: true,
};
/**
 * Configs for Typesense organizations search in site map.
 *
 * Here we don't configure `drop_tokens_threshold` nor `typo_tokens_threshold` because the
 * search keyword is chosen by us
 */
export const typesenseConfigForSiteMapUsers = {
    min_len_1typo: 4,
    min_len_2typo: 8,
    infix: ["off", "always"],
    // Cache for identical search
    use_cache: true,
};
/**
 * Configs for Typesense organizations search in global site search.
 *
 * We don't configure infix here because it doens't work well
 * with multi search, need to check with Typesense team
 */
export const typesenseConfigForSiteSearchOrganizations = {
    min_len_1typo: 4,
    min_len_2typo: 8,
    // Trying to match as many results as possible, but not monopolizing
    // CPU in one query
    drop_tokens_threshold: 10,
    typo_tokens_threshold: 10,
    // Cache for identical search
    use_cache: true,
};
/**
 * Configs for Typesense organizations search in site map.
 *
 * Here we don't configure `drop_tokens_threshold` nor `typo_tokens_threshold` because the
 * search keyword is chosen by us
 */
export const typesenseConfigForSiteMapOrganizations = {
    min_len_1typo: 4,
    min_len_2typo: 8,
    infix: ["off", "always"],
    // Cache for identical search
    use_cache: true,
};
export const typesenseConfigForProfile = {
    ...typesenseTypoConfigForProjectsCollection,
    // When filtering in user profile page, we want to find and return _ALL_ matches
    exhaustive_search: true,
};
// Only up to 3 sort fields are allowed in a single search query.
// See https://typesense.org/docs/26.0/api/search.html#ranking-and-sorting-parameters
export const typesenseProjectsCollectionDefaultSort = "star_count:desc,_text_match:desc,comment_count:desc";
export const typesenseUsersCollectionDefaultSort = "follower_count:desc,_text_match:desc,parts_count:desc";
export const typesenseOrganizationsCollectionDefaultSort = "follower_count:desc,_text_match:desc,partsCount:desc";
export const typesenseConfigForPartCollection = {
    // Cache for identical search
    use_cache: true,
    /**
     * Below tries to mirror algolia index config in `functions-algolia -> indexConfig.ts`
     *
     * NOTE these are already default behavior in Typesense:
     * - queryType: "prefixLast"
     * - advancedSyntax: true - support double quotes and minus to do exact/exclude search
     * - removeStopWords: false - when we dont setup any stop words in Typesense, this is already the behavior
     */
    // minWordSizefor1Typo in algolia config
    min_len_1typo: 7,
    // minWordSizefor2Typos in algolia config
    min_len_2typo: 12,
    // hitsPerPage in algolia config
    per_page: 10,
    // paginationLimitedTo in algolia config
    limit_hits: 20000,
    // maxValuesPerFacet in algolia config
    max_facet_values: 100,
    // attributesToRetrieve in algolia config
    include_fields: "archived,description,footprint_count,has_behaviour,layout_count,name,owner_handle,partVersionData,preview_image,star_count,three_d_model_count,uid,use_count,version",
    // unretrievableAttributes in algolia config
    exclude_fields: "anyoneCanView,userAccessList",
    // highlightPreTag and highlightPostTag in algolia config
    highlight_start_tag: "<em>",
    highlight_end_tag: "</em>",
    // removeWordsIfNoResults: "none" in algolia config
    drop_tokens_threshold: 0,
    sort_by: "_text_match:desc,contentScore:desc,updated_at:desc",
    // allowTyposOnNumericTokens in algoliaConfig
    // TODO: Need to upgrade sdk to support this
    // enable_typos_for_numerical_tokens: false,
    // Not supported in Typesense
    // cameCaseAttributes
    // TODO: See hwo to support these
    // exactOnSingleWordQuery, alternativesAsExact
};
//# sourceMappingURL=config.js.map